// src/App/Animations/HeroAnimation.js
import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(SplitText);

import Animation from "./Animation.js";

export default class ProjectAnimation extends Animation {
  constructor(element) {
    super(element);
  }

  setInitialState() {
    this.title = this.element.querySelector(".project__title");
    this.splitTitle = SplitText.create(this.title, { linesClass: "line" });

    this.link = this.element.querySelector(".project__link");
    this.splitLink = SplitText.create(this.link, { linesClass: "line" });
    this.svg = this.element.querySelector('svg')

    this.subtitles = this.element.querySelectorAll(".project__subtitle");
    this.splitSub = SplitText.create(this.subtitles, { linesClass: "line" });

    this.texts = this.element.querySelectorAll(".project__text");
    this.splitTexts = SplitText.create(this.texts, { linesClass: "line" });

    gsap.set(this.splitTitle.chars, { yPercent: 100 });
    gsap.set(this.splitLink.words, { yPercent: 100 });
    gsap.set(this.svg, { yPercent: 125 });
    gsap.set(this.splitSub.words, { yPercent: 110 });
    gsap.set(this.splitTexts.words, { yPercent: 100 });
  }

  createTimeline() {
    const tl = gsap.timeline({ paused: true });

    tl.to(this.splitTitle.chars, {
      // autoAlpha: 1,
      yPercent: 0,
      duration: 0.75,
      stagger: 0.015,
      ease: "back.out",
    })
      .to(
        this.splitLink.words,
        {
          yPercent: 0,
          ease: "power3.out",
        },
        "<0.25"
      )
            .to(
        this.svg,
        {
          yPercent: 0,
          ease: "power3.out",
        },
        "<"
      )
      .to(
        this.splitSub.words,
        {
          yPercent: 0,
          duration: 0.75,
          ease: "power3.out",
        },
        "<"
      )
      .to(
        this.splitTexts.words,
        {
          yPercent: 0,
          duration: 0.75,
          ease: "power3.out",
        },
        "<0.25"
      );

    return tl;
  }
}
